"use client";
import React from "react";
import { useIntl } from "react-intl";
import LegalContent from "../../Components/Legal/LegalContent";
import "../terms-and-conditions/page.css";
import "./page.css";

const CookiePolicyPage = () => {
  const intl = useIntl();

  return (
    <div className="tnc-page">
      <div className="container">
        <h1 className="tnc-title">
          {intl.formatMessage({ id: "cookiePolicy" })}
        </h1>
        <section className="tnc-card cookie-policy-card">
          <LegalContent src="/legal/cookie-policy.html" />
        </section>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
